<template>
  <div
    class="border-gray flex flex-col items-center gap-4 rounded-lg border bg-white p-4 shadow-lg"
  >
    <img
      class=""
      src="@/assets/loads/load-welcome.svg"
      alt="welcome image"
    />

    <div class="flex flex-col">
      <h4 class="text-left text-2xl font-medium text-dark-gray">Welcome</h4>

      <p class="text-left font-normal text-neutral-subtle-bold">
        To view loads, connect your ELD to verify your equipment, share your
        cargo policy, and protect your own identity.
      </p>
    </div>

    <div class="relative flex w-full items-center gap-2">
      <img
        class="rounded-full bg-gray-100 p-1"
        src="@/assets/loads/avatar.svg"
        alt="wifi icon"
      />
      <img
        v-if="isIdentityVerified"
        class="absolute bottom-0 left-6"
        src="@/assets/loads/green-check.svg"
        alt="green check"
      />

      <p class="text-base text-dark-gray">Protect your own identity</p>
    </div>

    <div class="relative flex w-full items-center gap-2">
      <img
        class="rounded-full bg-yellow-100 p-1"
        src="@/assets/loads/orange-wifi.svg"
        alt="wifi icon"
      />
      <img
        v-if="isEldConnected"
        class="absolute bottom-0 left-6"
        src="@/assets/loads/green-check.svg"
        alt="green check"
      />

      <p class="text-base text-neutral-subtlest">Connect your ELD</p>
    </div>

    <div class="relative flex w-full items-center gap-2">
      <img
        class="rounded-full bg-gray-100 p-1"
        src="@/assets/loads/umbrella.svg"
        alt="wifi icon"
      />
      <img
        v-if="hasSharedCargoPolicy"
        class="absolute bottom-0 left-6"
        src="@/assets/loads/green-check.svg"
        alt="green check"
      />

      <p class="text-base text-neutral-subtlest">Share your cargo policy</p>
    </div>

    <button-main
      class="!h-[48px] !py-3 text-1md !font-medium !text-dark-gray"
      @click="handleLetsGo"
    >
      Let's Go
    </button-main>

    <a
      class="cursor-pointer text-left text-xs text-neutral-subtle-bold"
      href="/info-link"
    >
      Why does Highway need this info?
    </a>
  </div>
</template>

<script>
import ButtonMain from '@/components/Button.vue';

export default {
  name: 'Loads Connect ELD',
  components: {
    ButtonMain,
  },
  emits: ['handle-load-search'],
  computed: {
    userLoadBoardAccess() {
      return this.$store.state.users?.userLoadBoardAccess?.user;
    },
    isEldConnected() {
      return true;
      // return this.userLoadBoardAccess?.has_eld_connected_and_active;
    },
    hasSharedCargoPolicy() {
      return true;
      // return this.userLoadBoardAccess?.cargo_policy_on_file_and_active;
    },
    isIdentityVerified() {
      return true;
      // return this.userLoadBoardAccess?.has_completed_idv;
    },
  },
  methods: {
    handleConnectEldRedirect() {
      this.$router.push({
        name: 'ELDConnections',
      });
    },
    handleLetsGo() {
      if (!this.isEldConnected) {
        console.log("User's ELD is not connected");

        this.$router.push({
          name: 'ELDConnections',
        });
      } else if (!this.hasSharedCargoPolicy) {
        console.log('User does not have cargo policy on file');

        // open request updated COI
      } else if (!this.isIdentityVerified) {
        console.log('User is not completed identity verification');

        this.$router.push({
          name: 'IdentityVerification',
        });
      } else {
        this.$emit('handle-load-search');
      }
    },
  },
};
</script>
